import React from 'react';
import { useDispatch } from 'react-redux';
import { Column, Row } from '@shared/ui/atoms/StructuralLayout';
import { HeadlineMedium } from '@shared/ui/atoms/fonts/Headline';
import { BodyLarge } from '@shared/ui/atoms/fonts/Body';
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import { next } from "../../../store/onboarding.duck";
import { useTranslation } from "react-i18next";
import { ButtonSize } from '@shared/ui/atoms/buttons/ButtonStyling';

export default function OnboardingWelcome() {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  return (
    <div className="onboarding">
      <Column className="onboarding__content">
        <img style={{width: 320, marginBottom: 32}}
             className="onboarding__image"
             src="/assets/images/onboarding-home-image.png"
             alt="" aria-hidden={true} />
        <HeadlineMedium style={{marginBottom: 12}}>{t('onboarding.welcome')}</HeadlineMedium>
        <BodyLarge style={{marginBottom: 16}}>{t('onboarding.welcome-message')}</BodyLarge>

        <Row style={{marginBottom: 24, marginTop: 32}}>
          <PrimaryButton dataTest="onboarding-welcome-next"
                  size={ButtonSize.Large}
                  text="button.lets-go"
                  click={() => dispatch(next())}
                  fullWidth={true}/>
        </Row>
      </Column>
    </div>
  )
}
